module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Peru_Callao_Tank_2010-01-26_1120391.d5f32935.jpg";